import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const CustomSelect = ({ value, onChange, field, error }) => {
  return (
    <FormControl
      fullWidth
      margin="dense"
      error={error}
      size={"small"}
      required={field.required}
    >
      <InputLabel>{field.label}</InputLabel>
      <Select
        value={value || ""}
        onChange={onChange}
        label={field.label}
        onClose={() => {
          setTimeout(() => {
            document.activeElement.blur();
          }, 0);
        }}
      >
        {field.options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>This field is required</FormHelperText>}
      {!error && field.helperText && (
        <FormHelperText>{field.helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomSelect;
